export const normalizeCustomFieldList = (list) => {
  if (!Array.isArray(list)) return list
  return list
    .map((item) => {
      if (!item) return null
      const custom_field_id = item.custom_field_id ?? item?.custom_field?.id ?? item?.id
      if (!custom_field_id) return null
      return {
        custom_field_id,
        value: item.value ?? null,
      }
    })
    .filter(Boolean)
}
